export default __webpack_public_path__ + "static/media/utr-sports-logo.adc3ba04.svg";